





























import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'

settings =
  resources:
    organizer_invitation:
      resourceName: 'organizer_invitation'
      slug: 'organizer_invitations/:token/edit'

  vue:
    data: ->
      error: null
      isSubmitting: false
      magic_link:
        password: null
        password_confirmation: null
      tos:
        sponsor_terms_of_service: accepted: true

    created: ->
      return window.location.href = '/' if @isLoggedIn()
      @clearStash()

    computed:
      token: -> @$route.params.token

    methods:
      hiHandleContinueClicked: ->
        @magic_link.organizer_invitation_id = @prime.organizer_invitation.id
        @isSubmiting = true
        @error = null
        payload = { @magic_link, @tos }
        try
          response = await RecessAPI.registerMagicLink payload
          @error = response.errors[Object.keys(response.errors)[0]] if response.errors?
          if !@error
            @setCurrentMember(response.item)
            @navigateToDashboard()
        catch err
          console.log err
        finally
          @isSubmiting = false

export default VueOptions.vue settings
